import i18n from '@/application/i18n/i18n'

export const subscriptionsStaticData = () => {
  const PRICING_PLANS_2022_DISPLAY_DATA = {
    descriptions: {
      free: {
        'Ideal for merchants shipping under 50 parcels per month': i18n.t(
          'Ideal for merchants shipping under 50 parcels per month',
        ),
      },
      lite: {
        'Ideal for merchants shipping between 50 – 400 parcels per month': i18n.t(
          'Ideal for merchants shipping between 50 – 400 parcels per month',
        ),
      },
      growth: {
        'Ideal for merchants shipping between 400 – 1000 parcels per month': i18n.t(
          'Ideal for merchants shipping between 400 – 1000 parcels per month',
        ),
      },
      premium: {
        'Ideal for merchants shipping over 1000 parcels per month': i18n.t(
          'Ideal for merchants shipping over 1000 parcels per month',
        ),
      },
      enterprise: {
        'settings.plans.list.enterprise.description': i18n.t(
          'settings.plans.list.enterprise.description',
        ),
      },
    },
    features: {
      free: {
        'Use Sendcloud discounted rates': i18n.t('Use Sendcloud discounted rates'),
        'Integrate your shop (number differ per plan)': i18n.t('Integrate your shop (number differ per plan)'),
        'Pre-selected branded tracking emails': i18n.t('Pre-selected branded tracking emails'),
        'Service points embedded in checkout': i18n.t('Service points embedded in checkout'),
        'Email and live chat support': i18n.t('Email and live chat support'),
      },
      lite: {
        'All Free plan features': i18n.t('All Free plan features'),
        'Ship with your own carrier contract': i18n.t('Ship with your own carrier contract'),
        'All branded tracking emails, 2 languages': i18n.t('All branded tracking emails, 2 languages'),
        'Checkout plugin w/ standard delivery': i18n.t('Checkout plugin w/ standard delivery'),
        'Smart shipping rules (number differ per plan)': i18n.t('Smart shipping rules (number differ per plan)'),
      },
      growth: {
        'All Lite plan features': i18n.t('All Lite plan features'),
        'Multi-language tracking emails': i18n.t('Multi-language tracking emails'),
        'Branded tracking pages': i18n.t('Branded tracking pages'),
        'Checkout plugin w/ same-day delivery': i18n.t('Checkout plugin w/ same-day delivery'),
        'Phone support': i18n.t('Phone support'),
        'Pack & Go packing solution': i18n.t('Pack & Go packing solution'),
      },
      premium: {
        'All Growth plan features': i18n.t('All Growth plan features'),
        'Return portal': i18n.t('Return portal'),
        'Pack & Go packing solution': i18n.t('Pack & Go packing solution'),
        'Checkout plugin w/ nominated-day delivery': i18n.t('Checkout plugin w/ nominated-day delivery'),
        'Customer Success Manager': i18n.t('Customer Success Manager'),
      },
    },
  }

  return {
    PRICING_PLANS_2022_DISPLAY_DATA,

    SUBSCRIPTION_DESCRIPTIONS: {
      free: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.descriptions.free)[0],
      lite: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.descriptions.lite)[0],
      growth: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.descriptions.growth)[0],
      premium: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.descriptions.premium)[0],
      enterprise: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.descriptions.enterprise)[0],
    },

    SUBSCRIPTION_FEATURES_SUMMARY: {
      free: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.features.free),
      lite: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.features.lite),
      growth: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.features.growth),
      premium: Object.values(PRICING_PLANS_2022_DISPLAY_DATA.features.premium),
    },

    GROUP_ORDER_CHARGEBEE: {
      free: 1,
      lite: 2,
      growth: 3,
      premium: 4,
      enterprise: 5,
    },
  }
}
